import { ADMIN_ROUTE_PREFIX } from "@/types/constants/common";
import { AgentObj } from "@/types/interfaces/agents";

export const CALLOUTS_BASE_LINK = `${ADMIN_ROUTE_PREFIX}/agents/callouts`;

export type CalloutType = "founder" | "support" | "builder";
export type CalloutField = "founderCallout" | "supportCallout" | "builderCallout";

interface CalloutConfig {
  label: string;
  description: string;
  field: CalloutField;
  // Agreements shown for this callout type; null shows every primary agent
  agreements: string[] | null;
}

export const CALLOUT_CONFIGS: Record<CalloutType, CalloutConfig> = {
  founder: {
    label: "Agent Experience",
    description: "All active primary agents",
    field: "founderCallout",
    agreements: null,
  },
  support: {
    label: "Support",
    description: "Agent and Agency agreements",
    field: "supportCallout",
    agreements: ["Agent", "Agency"],
  },
  builder: {
    label: "New Agents",
    description: "Gold, Silver and Student agreements",
    field: "builderCallout",
    agreements: [
      "Agent - Gold",
      "Agent - Silver",
      "Agent - Student 1",
      "Agent - Student 2",
      "Agency - Gold",
      "Agency - Silver",
      "Agency - Student 1",
      "Agency - Student 2",
    ],
  },
};

export const CALLOUT_TYPES = Object.keys(CALLOUT_CONFIGS) as CalloutType[];

export const isCalloutType = (value?: string): value is CalloutType =>
  !!value && CALLOUT_TYPES.includes(value as CalloutType);

export const filterAgentsForCallout = (agents: AgentObj[], type: CalloutType) => {
  const { agreements } = CALLOUT_CONFIGS[type];
  return agreements ? agents.filter((agent) => agreements.includes(agent.agreement || "")) : agents;
};
